export default __webpack_public_path__ + "static/media/save_as_csv.0555cfaf.PNG";